<template>
  <div class="state-popup-rectangle-button">
    <p
      v-if="title"
      class="state-popup-rectangle-button_title"
    >
      {{ $t(title) }}<span v-if="required">*</span>
    </p>
    <div class="state-popup-rectangle-button_input-item">
      <RectangleButton
        :text-label="contentText"
        trailing-icon="icon-chevron-down"
        :outline="outline"
        :disabled="disabled"
        @click="onClick()"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "StatePopupRectangleButton",
  props: {
    title: {
      type: String,
      default: "",
    },
    contentText: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      if (this.disabled) return;
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/state-popup-rectangle-button";
</style>